.outer-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-grow: 1;
}

.left-container {
    width: 70%;
    display: flex;
    justify-content: center;
    overflow: auto;
    border-radius: 0;
}

.right-container {
    width: 30%;
    display: flex;
    flex-direction: column;
    overflow: auto;
    flex-shrink: 0;
    border-left: 1px solid var(--off-white-dk);
    background-color: #fff;
    align-self: stretch;
}

.right-container > div {
    height: auto;
    flex-shrink: 0;
}

.right-container > div:not(:first-child) {
    margin-top: 0;
}

.canvas-outer {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px;
    box-sizing: border-box;
}

.canvas-card {
    background-color: #fff;
    border-radius: 8px;
    width: 100%;
    max-width: 529px;
    padding: 16px;
    box-sizing: border-box;
    height: fit-content;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
}

.add-page-container {
    width: 100%;
    max-width: 529px;
    margin-top: 16px;
    height: 50px;
}

.inner-container {
    width: 100%;
    display: flex;
    justify-content: center;
    height: fit-content;
    min-height: 100%;
}

.fields-container {
    /* 529px is 500px for the field, plus 29px for the chrome around the field */
    width: 529px;
    margin-right: 28px; /* Centers container by adding a margin the same width as field drag handles */
    display: flex;
    flex-direction: column;
    padding: 100px 0;
}

.header-container {
    margin-left: 45px; /* Left aligns header with fields */
    padding-bottom: 32px;
}

.draggable-list-container * {
    overflow: visible; /* This overrides the overflow: hidden so the remove badge shows properly */
}

.field {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 8px 16px 0 16px;
    width: calc(100% - 32px); /* Full width minus padding */
}

.header-field {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 40px;
    padding: 0 16px;
    width: calc(100% - 32px); /* Full width minus padding */
}

.loading {
    margin: 3px 0 32px 29px; /* Set to match the placement of our actual field */
}

.submit-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 16px;
    width: calc(100% - 60px); /* Full width minus padding and border */
    margin: 24px 0 0 26px; /* This lines up the submit button with the fields */
}

.submit-container:hover {
    background-color: var(--off-white);
}

.spacer {
    height: 16px;
}
